import { render, staticRenderFns } from "./bookingForm.vue?vue&type=template&id=5f089e7c"
import script from "./bookingForm.vue?vue&type=script&lang=js"
export * from "./bookingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports